<template>
<div>
    <div :class="{'content p-4': this.border}">
    <h5 v-if='this.message' class='mb-0 neue-roman'>
        {{this.message}}
    </h5>
    <div v-if="this.get_transact && this.get_sum && this.get_res" class="table-responsive col-12 p-0 mt-3">
        <table class="table table-borderless neue-roman m-0">
            <tbody class=''>
                <tr>
                    <td class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.3') }} </span>
                    </td>
                    <td class="align-middle neue p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <span class="d-flex flex-row align-items-center">{{this.get_transact}} <i class='item-i ml-1 copy c18 cli_transact pointer' :data-clipboard-target="'#_transact'"></i></span>
                        <input type='hidden' :id='"_transact"' :value="this.get_transact"/>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.1') }} </span>
                    </td>
                    <td class="align-middle neue-roman p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <span>{{this.get_sum}}</span>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.2') }}</span>
                    </td>
                    <td class="align-middle neue-roman p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <span>{{this.get_res}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="mt-3" v-if="this.get_done === '0'">
            <Button class='' :name="$t('components.service.PayStatusTemplate.4')" type='btn-outline-warning' v-on:click='this.getParamsExtTransact'/>
        </div>
    </div>
    <div v-else class="loader-div mt-2">
        <slot name="loader">

        </slot> 
    </div>
    </div>
    <h4 class='neue-roman mt-3'>{{ $t('components.service.PayStatusTemplate.5') }}</h4>
    <slot name="links">

    </slot>
</div>
</template>

<script>
    import Button from '@/components/service/Button';

    export default {
        components: {
            Button
        },
        data() {
            return {
                
            }
        },
        props: {
            message: [String, Boolean],
            get_transact: [String, Boolean],
            get_sum: [String, Boolean], 
            get_res: [String, Boolean],
            get_done: [String, Boolean],
            border: [Boolean],
        },
        methods: {
            getParamsExtTransact() {
                this.$emit('getParamsExtTransact');
            },
        }
    }
</script>

<style lang="scss" scoped>
  .content {
    box-shadow: 1px 2px 4px 1px rgb(19 110 0 / 24%) !important;
  }
  .loader-div {
    position: relative;
    min-height: 50px;
    width: 50px;
    z-index: 2000;
  }
  .mw_130 {
    width: 120px;
  }
</style>